import React from 'react';
import ReactLoading from 'react-loading';

function Loader() {
  return (
    <div style={{
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    }}>
      <ReactLoading
        type="spinningBubbles"
        color={'#91d5ff'}
        height={'100px'}
        width={'100px'} />
    </div>
  );
}

export default Loader;